import cx from 'classnames';
import { forwardRef } from 'react';

import { ConditionalView } from '../../utils/ConditionalView';
import styles from './Input.module.scss';
import usePresenter from './Input.presenter';
import type { InputProps } from './Input.types';

const Input = forwardRef<HTMLInputElement, InputProps>((props: InputProps, ref) => {
  const {
    variantProps,
    onInputChanged,
    otherInputProps,
    leadingIcon,
    trailingIcon,
    value,
    disabled,
    invalid,
    inputType,
    required,
    inputRef,
  } = usePresenter(props, ref);

  return (
    <div
      className={cx(
        styles.input,
        props.className,
        {
          [styles.disabled]: disabled, // to apply styles for disabled state to parent div
          [styles.error]: invalid, // to apply styles for error state to parent div
        },
      )}
      {...variantProps}
    >
      <ConditionalView condition={leadingIcon}>
        <div className={cx(styles.leadingIcon)}>
          {leadingIcon}
        </div>
      </ConditionalView>
      <input
        {...otherInputProps}
        aria-invalid={invalid}
        className={cx(styles.inputElement)}
        value={value || ''}
        onChange={onInputChanged}
        disabled={disabled}
        type={inputType}
        required={required}
        ref={inputRef}
        id={props.id}
      />
      <ConditionalView condition={trailingIcon}>
        <div className={cx(styles.trailingIcon)}>
          {trailingIcon}
        </div>
      </ConditionalView>
    </div>
  );
});

export default Input;
